export default "__VITE_ASSET__Ct5pcTiB__"